export const LEQ_updateCurrentScreenReducer = {
  LEQ_updateCurrentScreen: (state, action) => {
    state.currentScreen = action.payload;
  },
};
